import { render, staticRenderFns } from "./route_addresses.vue?vue&type=template&id=70c22958&"
import script from "./route_addresses.vue?vue&type=script&lang=js&"
export * from "./route_addresses.vue?vue&type=script&lang=js&"
import style0 from "./route_addresses.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports